import React from "react";
import { useDraggable } from "@dnd-kit/core";

export default function FieldPalette({ fieldTypes = [] }) {
  return (
    <aside className="rounded-xl border bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">Field Types</h3>
      <p className="mt-1 text-xs text-gray-500">Sleep veldtypes naar een sectie in het canvas.</p>

      <div className="mt-3 space-y-2">
        {fieldTypes.map((item) => (
          <PaletteField key={item.type} item={item} />
        ))}
      </div>
    </aside>
  );
}

function PaletteField({ item }) {
  const id = `palette:${item.type}`;
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <button
      ref={setNodeRef}
      type="button"
      style={style}
      className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-left text-sm font-medium text-gray-800 hover:bg-gray-100"
      {...listeners}
      {...attributes}
    >
      {item.label}
    </button>
  );
}
